export default [
    {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
        ability: 'painel.ver',
    },
    {
        title: 'Tempo Real',
        route: 'Frota',
        icon: 'MapPinIcon',
        ability: 'tempo_real.ver',
    },
    {
        title: 'Monitoramento',
        route: 'Monitoramento',
        icon: 'MapPinIcon',
        ability: 'monitoramento.ver',
    },
    {
        title: 'Roteirização',
        route: 'Roteirização',
        icon: 'MapPinIcon',
        ability: 'roteirizacao.ver',
    },
    {
        title: 'Videomonitoramento',
        route: 'HikCameras',
        icon: 'VideoIcon',
        ability: 'videomonitoramento.ver',
    },
    // {
    //   title: 'Programação',
    //   route: 'mobile-position',
    //   icon: 'CalendarIcon',
    // },
    // {
    //    title: 'Remoções',
    //    route: 'remotions',
    //    icon: 'TruckIcon',
    //  },
    // {
    //   title: 'Logs de Posições',
    //   route: 'logs_positions',
    //   icon: 'ZapIcon',
    // },
    {
        title: 'Registrations',
        icon: 'FileTextIcon',
        children: [
            {
                title: 'Company',
                route: 'list-companies',
                ability: 'empresas.ver',
            },

            {
                title: 'Users',
                route: 'list-users',
                ability: 'usuarios.ver',
            },

            {
                title: 'Papéis',
                route: 'list-roles',
                ability: 'papeis.ver',
            },

            {
                title: 'Centrals',
                route: 'list-centers',
                ability: 'centrais.ver',
            },

            {
                title: 'Units',
                route: 'list-units',
                ability: 'unidades.ver',
            },

            {
                title: 'Workers',
                route: 'list-workers',
                ability: 'workers.ver',
            },

            {
                title: 'Insurers',
                route: 'list-insurances',
                ability: 'seguradoras.ver',
            },
            {
                title: 'Types Of Fine',
                route: 'list-fine_types',
                ability: 'tipos_multa.ver',
            },
            {
                title: 'Gas station',
                route: 'list-gasstations',
                ability: 'postos.ver',
            },


            {
                title: 'Type Of Professional',
                route: 'list-typeprofessionals',
                ability: 'tipos_profissional.ver',
            },
            {
                title: 'Professionals',
                route: 'list-professionals',
                ability: 'profissionais.ver',
            },
            {
                title: 'Activities',
                route: 'list-activities',
                ability: 'atividades.ver',
            },
            // {
            //   title: 'Remoções Manuais',
            //   route: 'list-removals',
            // },
            // {
            //   title: 'Phone Types',
            //   route: 'list-telephone_type',
            // },
            // {
            //   title: 'Types of address',
            //   route: 'list-address_type',
            // },
            {
                title: 'Landmarks',
                route: 'list-landmarks',
                ability: 'pontos_referencia.ver',
            },
            {
                title: 'Landmark Types',
                route: 'list-landmark_types',
                ability: 'tipos_ponto_referencia.ver',
            },

        ],
    },

    {
        title: 'Expenses',
        icon: 'DollarSignIcon',
        children: [
            {
                title: 'Supplies',
                route: 'list-refuelings',
                ability: 'abastecimentos.ver',
            },
            {
                title: 'Manutenções',
                route: 'list-maintenances',
                ability: 'manutencoes.ver',
            },
            {
                title: 'Licensing',
                route: 'list-licensings',
                ability: 'licenciamentos.ver',
            },
            {
                title: 'IPVA',
                route: 'list-vehicle-ipvas',
                ability: 'ipva.ver',
            },
            {
                title: 'Fines',
                route: 'list-fines',
                ability: 'multas.ver',
            },
            {
                title: 'Insurance',
                route: 'list-auto_insurances',
                ability: 'seguros.ver',
            },

        ],
    },
    {
        title: 'Vehicles',
        icon: 'TruckIcon',
        children: [
            {
                title: 'Vehicle Brands',
                route: 'list-vehicle_brands',
                ability: 'marcas_veiculo.ver',
            },
            {
                title: 'Vehicle Models',
                route: 'list-vehicle_models',
                ability: 'modelos_veiculo.ver',
            },
            {
                title: 'Vehicle Colors',
                route: 'list-vehicle_colors',
                ability: 'cores_veiculo.ver',
            },
            {
                title: 'Vehicle Type',
                route: 'list-vehicle_types',
                ability: 'tipos_veiculo.ver',
            },
            {
                title: 'Vehicles',
                route: 'list-vehicles',
                ability: 'veiculos.ver',
            },
            {
                title: 'Origins',
                route: 'list-origins',
                ability: 'origens.ver',
            },
            {
                title: 'Vehicle Licensing Month',
                route: 'list-vehicle-licensing-months',
                ability: 'meses_licenciamento.ver',
            },
        ]
    },
    {
        title: 'Devices',
        icon: 'DiscIcon',
        children: [

            {
                title: 'Suppliers',
                route: 'list-supplier',
                ability: 'fornecedores.ver',
            },
            {
                title: 'Devices Model',
                route: 'list-deviceModels',
                ability: 'modelos_dispositivo.ver',
            },
            {
                title: 'Device Type',
                route: 'list-deviceTypes',
                ability: 'tipos_dispositivo.ver',
            },
            {
                title: 'Operators',
                route: 'list-Operators',
                ability: 'operadoras.ver',
            },
            {
                title: 'Chips',
                route: 'list-Chips',
                ability: 'chips.ver',
            },
            {
                title: 'Devices',
                route: 'list-devices',
                ability: 'dispositivos.ver',
            },
            // {
            //     title: 'Devices Activation',
            //     route: 'list-devicesActivation',
            // },
        ]

    },
    {
        title: 'Events',
        icon: 'ZapIcon',
        children: [
            // {
            //     title: 'Criticality types',
            //     route: 'list-criticalitytypes',
            // },
            // {
            //     title: 'Event types',
            //     route: 'list-eventTypes',
            // },
            // {
            //     title: 'Sensors',
            //     route: 'list-Sensors',
            // },
            {
                title: 'Monitoring',
                route: 'list-monitorings',
                ability: 'eventos.ver',
            },
        ]
    },
    {
        title: 'Area',
        icon: 'MapPinIcon',
        children: [
            // {
            //   title: 'Types of area',
            //   route: 'list-areatypes',
            // },
            {
                title: 'Catagories of Area',
                route: 'list-areacatagories',
                ability: 'categorias_area.ver',
            },
            {
                title: 'Area',
                route: 'list-areas',
                ability: 'areas.ver',
            },

        ]
    },
    {
        title: 'Movias',
        icon: 'SettingsIcon',
        children: [
            {
                title: 'Configurações',
                route: 'list-moviasEventRules',
                ability: 'eventos_movias.ver',
            },
        ]
    },
    // {
    //   title: 'operational panel', // Operational Panel
    //   route: 'list-operational_panel',
    //   icon: 'ActivityIcon',
    // },
    // {
    //   title: 'Rescue',
    //   icon: 'GlobeIcon',
    //   children: [
    //   ]
    // },

    // {
    //   title: 'Rescue',
    //   icon: 'GlobeIcon',
    //   children: []}

    // {
    //   title: 'Chat',
    //   route: 'chat',
    //   icon: 'MessageSquareIcon',
    // },
]
